import { useState, useEffect } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from '../Loader/Loader';
import { get_AstroData } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";


const AstrologerTotalTime = () => {
    const dispatch = useDispatch();
    const Astrodata = useSelector((state) => state.feedBackReducer.AstroData);

    const [timedata, setTimeData] = useState([]);
    const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
    const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [loading, setLoading] = useState(false);
    const [astroname, setAstroname] = useState("");
    const [selectedAstro, setSelectedAstro] = useState(null);


    useEffect(() => {
        dispatch(get_AstroData("1"));
    }, [])


    useEffect(() => {
        if (Astrodata && Array.isArray(Astrodata)) {
            const filtered = Astrodata.map(({ DisplayName, ID }) => ({
                label: DisplayName,
                value: ID,
            }));
            setAstroname(filtered);

        }
    }, [Astrodata]);


    const fetchData = async () => {
        const postdata = { AstroID: selectedAstro?.value, StartOnlineTimeFrom: startTime, StartOnlineTimeTo: endTime };

        try {
            setLoading(true);
            const res = await AddUpdate("Users/GetData_OnlineOfflineStatus", postdata);
            if (res?.data?.data) {
                const data = JSON.parse(res?.data?.data)

                const finaldata = data?.Table

                setTimeData(finaldata);
            }

            else {
                setTimeData([]);
            }


        } catch (error) {
            console.log("error", error);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, [])


const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return "-";

  const date = new Date(dateTimeStr);
  if (isNaN(date.getTime())) return "-";

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${month} ${day} ${year} ${hours}:${minutes}:${seconds}${ampm}`;
};


    const columns = [
        {
            name: "Astrologer Name",
            selector: (row) => row.Astroname,
            sortable: true,
        },
        {
            name: "Is Online",
            selector: (row) => row.IsOnline ? "Online" : "Offline",
            sortable: true,
        },
        {
            name: "Start Online Time",
            selector: (row) => row.StartOnlineTime,
            sortable: true,
        }, {
            name: "End Online Time",
            selector: (row) => formatDateTime(row.EndOnlineTime),
            sortable: true,


        },
        {
            name: "Total Time",
            selector: (row) => row.OnlineDuration,
            sortable: true,
        }
    ];

    function handleSearch() {
        fetchData();
    }


    return (
        <>
            <div className="form-group  main_card">
                <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Astrologer Total Login Time</h2>
                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Start Time</label>
                        <input
                            type="date"

                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input
                            type="date"

                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">Astrologer Name</label>
                        
                       
                        <Select
                            value={selectedAstro}
                            onChange={(selectedOption) => setSelectedAstro(selectedOption)}
                            options={astroname}
                            placeholder="Select Astrologer"
                            isSearchable
                        />
                    </div>




                    <div className="col-auto">
                        <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
                            Search
                        </button>

                    </div>
                </div>
            </div>

            <div className="col-12 mt-2  main_card">
                {
                    loading ? <Loader /> :

                        <DataTable
                            dense
                            data={timedata || []}
                            columns={columns}
                            selectableRowsHighlight
                            pagination
                            customStyles={customStyles}
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                        />
                }
            </div>




        </>
    )
}
export default AstrologerTotalTime;